import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { sendConfiguratorResetStep } from "~/features/configurator/common/api/configuratorCommandApi";
import { transform } from "~/features/configurator/Linear/linearDataTransformer";
import type { ConfiguratorCsticTarget } from "~/features/configurator/common/api/configuratorCommands";

export async function sendShaftDataReset(
  linearState: LinearConfiguratorState,
  resetTargets?: ConfiguratorCsticTarget[],
): Promise<LinearConfiguration> {
  const response = await sendConfiguratorResetStep(linearState, resetTargets);
  return transform(response, linearState.type!, undefined);
}
